import React from "react";
import { Tag } from "antd";
import { BatchJob } from "reducers/types";

const JobStatusTag: React.FC<{ job: BatchJob }> = ({ job }) => {
  switch (job.status) {
    case "PENDING":
      return <Tag>{job.queuePosition ? `Queued #${job.queuePosition}` : "Queued"}</Tag>;
    case "RUNNING":
      return <Tag color="blue">{job.cancelRequested ? "Cancelling…" : "Running"}</Tag>;
    case "AWAITING_APPROVAL":
      return <Tag color="orange">Needs approval</Tag>;
    case "WAITING_FOR_PROVIDER":
      return <Tag color="gold">Waiting for provider</Tag>;
    case "COMPLETED":
      return job.failed > 0 ? (
        <Tag color="orange">Completed with {job.failed} failed</Tag>
      ) : (
        <Tag color="green">Completed</Tag>
      );
    case "FAILED":
      return <Tag color="red">Failed</Tag>;
    case "CANCELLED":
      return <Tag>Cancelled</Tag>;
    default:
      return <Tag>{job.status}</Tag>;
  }
};

export default JobStatusTag;
